import { apiService } from './api.service';
import { CR_API_ENDPOINTS } from '../constants';
import { Setting } from '../types';

class SettingsService {
  async getAll(): Promise<Setting[]> {
    return apiService.get<Setting[]>(CR_API_ENDPOINTS.SETTINGS);
  }

  async getByType(type: string): Promise<Setting> {
    return apiService.get<Setting>(`${CR_API_ENDPOINTS.SETTINGS}/type/${type}`);
  }

  async getById(id: string): Promise<Setting> {
    return apiService.get<Setting>(`${CR_API_ENDPOINTS.SETTINGS}/${id}`);
  }

  async create(data: { type: string; value: unknown; description?: string }): Promise<Setting> {
    return apiService.post<Setting>(CR_API_ENDPOINTS.SETTINGS, data);
  }

  async update(id: string, data: { value?: unknown; description?: string }): Promise<Setting> {
    return apiService.put<Setting>(`${CR_API_ENDPOINTS.SETTINGS}/${id}`, data);
  }

  async updateByType(type: string, data: { value?: unknown; description?: string }): Promise<Setting> {
    return apiService.put<Setting>(`${CR_API_ENDPOINTS.SETTINGS}/type/${type}`, data);
  }

  async delete(id: string): Promise<void> {
    return apiService.delete<void>(`${CR_API_ENDPOINTS.SETTINGS}/${id}`);
  }
}

export const settingsService = new SettingsService();
